import { Component, OnInit } from '@angular/core';
import { MenuService } from '../menu/menu.service';
import { PageTitleService } from '../../../shared/page-title.service';

@Component({
    selector: 'app-favorites',
    templateUrl: './favorites.component.html',
    styleUrls: ['./favorites.component.scss'],
    standalone: false
})
export class FavoritesComponent implements OnInit {
  toppings;
  toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

  public menuItems;
  public favorites;
  pageTitle$ = this.pageTitleService.title;

  constructor(
    public menuService: MenuService,
    public pageTitleService: PageTitleService
  ) {}

  ngOnInit() {
    this.menuService.getVerticalMenuItems().then((menuItems) => {
      this.menuItems = menuItems.filter(menu => menu.routerLink != null || menu.href != null);;
    });
  }

  trackByTitle(index: number, item: any) {
    return item.title;
  }

  trackById(index: number, item: any) {
    return item.id;
  }

}
